import { Search, X, Leaf } from "lucide-react";

const MENU_TABS = [
  { slug: "starters", label: "Starters" },
  { slug: "mains", label: "Main Course" },
  { slug: "biryani", label: "Biryani & Breads" },
  { slug: "chinese", label: "Indo-Chinese" },
];

export default function MenuNav({ query, setQuery, vegOnly, setVegOnly, resultCount, onSelectCategory }) {
  return (
    <div
      data-testid="menu-nav"
      className="sticky top-[69px] z-40 bg-[#0B1319]/95 backdrop-blur-md border-b border-[#1E313D]"
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <div className="flex items-center gap-2 overflow-x-auto">
          {MENU_TABS.map((tab) => (
            <button
              key={tab.slug}
              onClick={() => onSelectCategory?.(tab.slug)}
              data-testid={`menu-tab-${tab.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="whitespace-nowrap px-4 py-1.5 text-xs font-semibold uppercase tracking-wider rounded-full border border-[#1E313D] text-[#A8B8C0] hover:border-[#D4AF37]/60 hover:text-[#F7D774] transition-colors"
            >
              {tab.label}
            </button>
          ))}
          <button
            onClick={() => setVegOnly(!vegOnly)}
            data-testid="veg-only-toggle"
            aria-pressed={vegOnly}
            className={`whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider rounded-full border transition-colors ${
              vegOnly
                ? "border-green-500/70 bg-green-500/15 text-green-400"
                : "border-[#1E313D] text-[#A8B8C0] hover:border-green-500/50 hover:text-green-400"
            }`}
          >
            <Leaf size={13} />
            Veg Only
          </button>
        </div>
        <div className="relative sm:ml-auto w-full sm:w-72">
          <Search
            size={15}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A8B8C0] pointer-events-none"
          />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search dishes — biryani, paneer, kebab…"
            data-testid="menu-search-input"
            className="w-full bg-[#111D25] border border-[#1E313D] rounded-full pl-9 pr-9 py-2 text-sm text-[#F3EAD8] placeholder:text-[#6C7D86] focus:outline-none focus:border-[#D4AF37]/70 transition-colors"
          />
          {query && (
            <button
              onClick={() => setQuery("")}
              data-testid="menu-search-clear"
              aria-label="Clear search"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A8B8C0] hover:text-[#F7D774] transition-colors"
            >
              <X size={15} />
            </button>
          )}
        </div>
      </div>
      {query && (
        <p
          data-testid="menu-search-count"
          className="max-w-7xl mx-auto px-6 pb-2 text-xs text-[#D4AF37]"
        >
          {resultCount} dish{resultCount === 1 ? "" : "es"} matching “{query}”
        </p>
      )}
    </div>
  );
}
